import { api, type ChangeSetView, type Intent } from '../api/client';

/**
 * A quick action (log an agent out, switch a rule on): planned and applied in one go, so it
 * still gets the same checks, history and undo as any other change.
 */
export async function quickChange(tenant: string, intents: Intent[], title?: string): Promise<ChangeSetView> {
  const { changeSet } = await api.plan(tenant, intents, title);
  const { changeSet: applied } = await api.apply(changeSet.id);
  return applied;
}
